import { FreeMode, Navigation, Thumbs } from 'swiper/modules'
import React, { useEffect, useRef, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import Popup from 'components/popups/Popup'
import SwiperCore from 'swiper'
import './_index.scss'

import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import 'swiper/css/thumbs'

export interface ImageData {
  document_title: string
  public_path: string
  thumbnail: string
}

interface GalleryModalProps {
  initialSlide?: number
  data: ImageData[]
  onlyBody?: boolean
}

const style = {
  '--swiper-navigation-color': '#7c7c7c',
  '--swiper-pagination-color': '#7c7c7c',
} as React.CSSProperties

const GalleryModal: React.FC<GalleryModalProps> = ({ data, initialSlide, onlyBody }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperCore | null>(null)
  const mainSwiper = useRef<SwiperCore | null>(null)

  const loop = data.length > 1

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowLeft') mainSwiper.current?.slidePrev()
      else if (e.key === 'ArrowRight') mainSwiper.current?.slideNext()
    }
    window.addEventListener('keydown', onKeyDown)
    return () => {
      window.removeEventListener('keydown', onKeyDown)
    }
  }, [])

  const gallery = <div className='modal__gallery'>
    <Swiper
      navigation
      loop={loop}
      style={style}
      onSwiper={(swiper: SwiperCore) => {
        mainSwiper.current = swiper
      }}
      spaceBetween={10}
      initialSlide={initialSlide}
      thumbs={{ swiper: thumbsSwiper }}
      modules={[FreeMode, Navigation, Thumbs]}
      className='gallery__swiper'>
      {data.map(({ document_title, public_path }, idx) => <SwiperSlide
        key={idx}
        className='center'>
        <img
          src={public_path}
          alt={document_title}
        />
      </SwiperSlide>)}
    </Swiper>
    <Swiper
      freeMode
      loop={loop}
      spaceBetween={10}
      slidesPerView='auto'
      watchSlidesProgress
      onSwiper={setThumbsSwiper}
      modules={[FreeMode, Navigation, Thumbs]}
      className='thumbs__swiper'>
      {data.map(({ document_title, thumbnail }, idx) => <SwiperSlide
        key={idx}
        className='center'>
        <img
          src={thumbnail}
          alt={document_title}
        />
      </SwiperSlide>)}
    </Swiper>
  </div>

  if (onlyBody) return gallery
  return (
    <Popup>
      {gallery}
    </Popup>
  );
}

export default GalleryModal